import React from "react";
import { Typography } from "@mui/material";

/**
 * Shared form primitives for the mobile app.
 *
 * The outlined-field styling is lifted from the desktop
 * `components/CustomFields` TextField so mobile inputs read identically to
 * desktop. `fieldSx` is handed to a plain MUI <TextField sx={...} /> rather than
 * wrapping it, so each screen keeps full control over the field's own props.
 */
export const fieldSx = (theme, error) => ({
  "& .MuiOutlinedInput-input": {
    ...theme.typography["body01-medium"],
    color: `${error ? theme.palette.danger.main : theme.palette.neutral["clr-800"]} !important`,
    padding: theme.spacing(3, 5),
    height: "fit-content",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette.neutral["clr-600"],
  },
  "& .MuiOutlinedInput-root": {
    height: "44px",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.shades["clr-white-900"],
    "& fieldset": {
      borderColor: error
        ? theme.palette.danger.main
        : theme.palette.neutral["clr-500"],
    },
    "&:hover fieldset": {
      borderColor: error
        ? theme.palette.danger.main
        : theme.palette.neutral["clr-500"],
    },
    "&.Mui-focused fieldset": {
      borderColor: error
        ? theme.palette.danger.main
        : theme.palette.primary["clr-300"],
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.neutral["clr-200"],
      "& fieldset": { borderColor: theme.palette.neutral["clr-400"] },
    },
  },
});

export function FieldLabel({ children }) {
  return (
    <Typography
      sx={(theme) => ({
        ...theme.typography["body01-bold"],
        textTransform: "capitalize",
        mb: 2,
        display: "block",
      })}
    >
      {children}
    </Typography>
  );
}

export function ErrorText({ children }) {
  return (
    <Typography
      sx={(theme) => ({
        ...theme.typography["body02-medium"],
        color: theme.palette.danger.main,
        mt: 1,
        display: "block",
      })}
    >
      {children}
    </Typography>
  );
}
